import { createContext, useContext } from 'react';
import { BookingCalendarConfig } from '@pages/booking/types';

export const BookingConfigContext = createContext<BookingCalendarConfig>({});

export const useBookingConfigContext = () => {
    return useContext(BookingConfigContext);
};
